import { useMutation, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'

import { customFieldRepository } from '@webapp/core/data-access/repositories/CustomFieldRepository/CustomFieldRepository'
import { CustomFieldTypes } from '@webapp/core/entities/internal/CustomField'
import { ContentTypeAppLabels } from '@webapp/core/entities/internal/enums/ContentTypeAppLabelEnum'
import { ContentTypeModels } from '@webapp/core/entities/internal/enums/ContentTypeModelEnum'
import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'
import { makeSelectContentTypesByModel } from '@webapp/core/stores/global'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type CreatePOCustomFieldFormSchema } from '@webapp/modules/purchasing/features/create-po-custom-field/views/CreatePOCustomFieldForm'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'

export const useMutateCreatePOCustomField = () => {
  const queryClient = useQueryClient()

  // Store-Sourced Redux read (not a query) — PO content-type id
  const poContentType = useSelector(
    makeSelectContentTypesByModel(
      ContentTypeAppLabels.PROCURIFY,
      ContentTypeModels.PO
    )
  )

  const mutation = useMutation<
    { id: number },
    RepoError,
    CreatePOCustomFieldFormSchema
  >({
    // PO custom fields are always plain text fields (Business Rule 4)
    mutationFn: (values) =>
      customFieldRepository.createCustomField({
        name: values.name,
        field_type: CustomFieldTypes.TEXT,
        is_required: false,
        content_type: poContentType?.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customFieldQueryConfig.allPurchaseOrder().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: poPdfLabelEditorQueryConfig.editorFields().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
